import React from "react";
import { useFormContext } from "react-hook-form";
import {
  ListItem,
  SelectOptionsType,
  SignUpFormData,
} from "../../../../SignUpFormTypes/signUpFormTypes";
import ScrollAreaOptions from "../ScrollAreaOptions";

type SuggestionSelectOptionsType = {
  autoSuggestionList: ListItem[];
} & SelectOptionsType;

const SuggestionSelectOptions: React.FC<SuggestionSelectOptionsType> = ({
  autoSuggestionList,
  setValue,
  setShowOptions,
}) => {
  const { getValues } = useFormContext<SignUpFormData>();

  const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    setValue("otherProfession", e.currentTarget.dataset.label ?? "", {
      shouldValidate: true,
      shouldTouch: true,
    });
    setShowOptions(false);
  };

  const boldString = (str: string, substr: string) => {
    const replacerToMaintainCase = (matchedChar: string) =>
      `<b>${matchedChar}</b>`;

    return str.replace(RegExp(substr, "gi"), replacerToMaintainCase);
  };

  const autoSuggestionComponentList =
    autoSuggestionList &&
    autoSuggestionList.map(({ autoSuggestionItem }) => (
      <li
        key={autoSuggestionItem}
        className={`flex justify-between items-center self-stretch py-2 pr-2 pl-4 hover:bg-forest-200 cursor-pointer`}
        data-label={autoSuggestionItem}
        onClick={handleClick}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: boldString(
              autoSuggestionItem ?? "",
              getValues("otherProfession")
            ),
          }}
        />
      </li>
    ));

  return (
    <ScrollAreaOptions showOptions={setShowOptions}>
      {autoSuggestionComponentList}
    </ScrollAreaOptions>
  );
};

export default SuggestionSelectOptions;
